import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/Login'
import Reset from '@/components/login/Reset'
import User from '@/components/user/User'
import ResetPwd from '@/components/user/ResetPwd'
import GoodsList from '@/components/goods/GoodsList'
import GoodsEdit from '@/components/goods/GoodsEdit'
import OrderList from '@/components/order/OrderList'
import OrderEdit from '@/components/order/OrderEdit'
import OrderInfo from '@/components/order/OrderInfo'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login/index'
    },
    {
      path: '/login/index',
      name: '登录页',
      component: Login
    },
    {
      path: '/login/reset',
      name: '找回密码',
      component: Reset
    },
    {
      path: '/user/index',
      name: '个人中心',
      component: User
    },
    {
      path: '/user/reset_pwd',
      name: '修改密码',
      component: ResetPwd
    },
    {
      path: '/goods/goods_list',
      name: '商品列表',
      component: GoodsList
    },
    {
      path: '/goods/goods_edit',
      name: '商品明细',
      component: GoodsEdit
    },
    {
      path: '/order/order_list',
      name: '订单列表',
      component: OrderList
    },
    {
      path: '/order/order_edit',
      name: '价格修改',
      component: OrderEdit
    },
    {
      path: '/order/order_info',
      name: '订单详情',
      component: OrderInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js